import { Component } from 'vue-property-decorator';
import BasicSearchPage from 'src/components/basicSearchPage/basicSearchPage';
import override from 'src/dectorators/override';
import AlgaPictureService from './service/algaPictureService';
import { AlgaPictureDOI } from './api/algaPictureApi';

@Component({ name: 'alga-picture' })
export default class AlgaPicture extends BasicSearchPage<AlgaPictureService, AlgaPictureDOI.RowDataI, AlgaPictureDOI.QueryRowDataParamsI> {
    @override
    renderHead(h) {
        return <div></div>;
    }

    @override
    loadService() {
        this.service = new AlgaPictureService(this);
    }
}
